'use strict';

/**
 *
 * @name: playlistOverlay
 *
 */

import DirectiveTemplate from './playlist-overlay-DEPRECATED.directive.html';

function PlaylistOverlayDirective($rootScope, $timeout, Playlist, transObject) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    scope: {
      overlaySettings: '=',
      post: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      var page = 1;
      var isLoading = false;
      scope.loadedAll = false;
      scope.playlists = [];
      scope.newPlaylist = {
        title: null
      };

      /**
       *
       * @PUBLIC_METHODS
       *
       */

      scope.addPostToPlaylist = function(index) {

        scope.playlistAddedTo = scope.playlists[index];
        addPostToPlaylist();
      };
      scope.createNewPlaylist = function() {

        var newPlaylist = new Playlist();
        newPlaylist.translations = [{
          language: $rootScope.lang,
          title: scope.newPlaylist.title
        }];
        newPlaylist.isPrivate = false;
        newPlaylist.type = 'memberPlaylist';
        newPlaylist.UserId = $rootScope.profile.id;

        newPlaylist
          .$save()
          .then(function(res) {

            transObject.translate(res);
            scope.playlistAddedTo = res;
            addPostToPlaylist();
          });
      };
      scope.loadMore = function() {


        if (!isLoading && !scope.loadedAll) {

          page++;

          getPlaylists();
        }
      };

      /**
       *
       * @PRIVATE_METHODS
       *
       */

      function getPlaylists() {
        isLoading = true;
        Playlist
          .get({
            UserId: $rootScope.profile.id,
            containsPost: scope.post.id,
            order: 'createdAt asc',
            page: page
          }).$promise
          .then(function(res) {

            res.items.forEach(function(item) {

              transObject.translate(item);

              if (!item.containsPost) {

                scope.playlists.push(item);
              }
            });

            isLoading = false;
            scope.loadedAll = (page === res.meta.totalPages);
          });
      }

      function addPostToPlaylist() {

        $rootScope.analytics.buttons('add to playlist', 'temporary label', scope.post);

        Playlist
          .addStory({
            id: scope.playlistAddedTo.id,
            postId: scope.post.id
          }).$promise
          .then(function() {

            scope.overlaySettings.show = 'addedTo';

            $timeout(function() {

              scope.overlaySettings.hasPlaylistOverlay = false;
            }, 3338);
          });
      }

      /**
       *
       * @INIT
       *
       */

      $(element).on('click.playlistOverlay', function(e) {

        e.stopPropagation();
        return;
      });

      $('body').on('click.playlistOverlay', function(e) {

        if ($(e.target).is('.action-buttons .playlist')) {

          e.stopPropagation();
          return;
        }
        void 0;

        scope.$apply(function() {
          scope.overlaySettings.hasPlaylistOverlay = false;
        });
      });


      scope.$on('$destroy', function() {

        $(element).off('click.playlistOverlay');
        $('.action-buttons .playlist').off('click.playlistOverlay');
        $('body').off('click.playlistOverlay');

      });

      if (scope.overlaySettings.show === 'list') {

        getPlaylists();
      } else {

        var firstWatcher = scope.$watch('overlaySettings.show', function(newVal) {

          if (newVal && scope.overlaySettings.show === 'list') {

            firstWatcher();
            getPlaylists();
          }
        });
      }
    }
  };
}

export default PlaylistOverlayDirective;



// WEBPACK FOOTER //
// ./app/pages/playlist/playlist-overlay-DEPRECATED.directive.js